export default (ctx, inject) => {
    const debug = false
    inject('storyblokNujek', { debug })
}